import React from 'react';
import {
    MDBCarousel, MDBCarouselInner, MDBCarouselItem, MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardImage,
    MDBCardBody, MDBCardTitle, MDBCardText, MDBBtn, MDBBadge, MDBInput, MDBIcon
} from "mdbreact";
import DataLayer from '../../Utilities/DataLayer';
import Formatter from '../../Utilities/Formatter'
import Colors from '../../Styles/Colors';


export default class TopSeller extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dataChunks: []
        }
        this.dl = new DataLayer();
        this.formatter = new Formatter();
        this.processData = this.processData.bind(this);
    }

    componentWillReceiveProps() {
        this.processData();
    }

    processData() {
        let dataChunks = [];
        let chunkEnd = 0;
        let chunk = []

        for (let chunkStart = 0; chunkStart < this.props.items.length; chunkStart += 3) {
            chunkEnd = chunkStart + 3;
            chunk = this.props.items.slice(chunkStart, chunkEnd);
            dataChunks.push(chunk);
        }

        this.setState({
            dataChunks
        });
    }

    render() {
        return (
            <MDBCarousel activeItem={1} length={2} slide={true} showControls={false} showIndicators={true} multiItem interval={3000}>
                <MDBCarouselInner>
                    <MDBRow>
                        {
                            this.state.dataChunks.map((chunk, index) => {
                                return (
                                    <MDBCarouselItem itemId={index + 1}>
                                        {
                                            chunk.map((item) => {
                                                return (
                                                    <MDBCol md="4" sm="12">
                                                        <MDBCard className="card-body mx-1 my-1">
                                                            <MDBCardText>
                                                                <MDBRow>
                                                                    <MDBCol>
                                                                        <span style={{ fontSize: "16", color:Colors.orange }}><strong><MDBIcon icon="fire-alt" />&nbsp;TOP SELLER</strong></span>
                                                                    </MDBCol>
                                                                    <MDBCol>
                                                                        <h5><MDBBadge className="priceBadge" color="secondary">Price: {this.formatter.formatCurrency(item.d)}</MDBBadge></h5>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            </MDBCardText>
                                                            <br />
                                                            <MDBCardText>
                                                                <MDBRow>
                                                                    <MDBCol>
                                                                        <span style={{ fontSize: "16" }}><strong>{item.processingCode}</strong></span><br />
                                                                        <span style={{ fontSize: "10" }}>{item.invoiceDescription}</span><br />
                                                                        <span style={{ fontSize: "16" }}>Recognition:&nbsp;<strong>{this.formatter.formatCurrency(item.recognition)}</strong></span><br />
                                                                    </MDBCol>
                                                                    <MDBCol className="text-center">
                                                                        <MDBBtn type="submit" tag="a" color="cyan" floating onClick={() => this.addToCart(item)}>
                                                                            <MDBIcon icon="cart-plus" />
                                                                        </MDBBtn>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            </MDBCardText>


                                                        </MDBCard>
                                                    </MDBCol>
                                                )
                                            })
                                        }
                                    </MDBCarouselItem>
                                )
                            })
                        }
                    </MDBRow>
                </MDBCarouselInner>
            </MDBCarousel>
        );
    }
}